import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class KpiAccessGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    const currentUserId = this.authService.getCurrentUserId();
    const authorizedUserIds = environment.kpiAuthorizedUserIds || [];

    if (currentUserId && authorizedUserIds.includes(currentUserId)) {
      return true;
    }

    return this.router.parseUrl('/home');
  }
}
